import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators';

@Pipe({ name: 'getText' })
export class GetTextPipe implements PipeTransform {
  transform(inputValue: any, idPropertyName: string, valuePropertyName: string, valueArray: Array<any> | Observable<Array<any>>): any {
    if (inputValue != null && valueArray != undefined) {
      if (Array.isArray(valueArray)) {
        let retIndex = valueArray.map(v => v[idPropertyName]).indexOf(inputValue);
        if (retIndex >= 0) {
          return valueArray[retIndex][valuePropertyName];
        }
      }
      else if (valueArray instanceof Observable) {
        return valueArray.pipe(
          map(va => {
            let filteredVals = va.filter(v => v[idPropertyName] == inputValue);
            if (filteredVals.length > 0) {
              return filteredVals[0][valuePropertyName];
            }
            else {
              return "";
            }
          })
        );
      }

    }

    return '';
  }
}
